// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"7af09cae","1393":"65bb074b"}[chunkId] + ".chunk.css";
};